"use client";

import type { FC, ReactNode } from "react";
import { createContext, useContext, useState } from "react";

interface TabsContextProps {
  currentTab: string | null;
  setCurrentTab: (tabIndex: string) => void;
  addedQueryParam: (tabIndex: string) => void;
}

const TabsContext = createContext<TabsContextProps | undefined>(undefined);

export const TabsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [currentTab, setCurrentTab] = useState<string | null>(null);

  function addedQueryParam(valorParametro: string) {
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;

    if (params.has("tab")) {
      params.delete("tab");
    }

    currentUrl.searchParams.append("tab", valorParametro);
    window.history.pushState({ path: currentUrl.href }, "", currentUrl.href);
  }

  return (
    <TabsContext.Provider
      value={{ currentTab, setCurrentTab, addedQueryParam }}
    >
      {children}
    </TabsContext.Provider>
  );
};

export const useTabs = (): TabsContextProps => {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error("useTabs must be used within a TabsProvider");
  }
  return context;
};
